module.exports = "/images/pk.svg?9206b73155ba8d49f89a8434769da903";